import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import VCERNTypography from "../common/elements/VCERNTypography";
import VCERNButton from "../common/elements/VCERNButton";

import { connect } from "react-redux";
import icons from "../common/icons";
import DashboardHeader from "../common/DashboardHeader";
import constants from "../common/constants";
import AC from "../redux/actions/actionCreater";
import { getFormattedDate } from "../common/helper";
import DocumentsList from "../common/DocumentsList";
import { useLocation } from "react-router-dom";
import VCERNModal from "../common/elements/VCERNModal";
import API from "../common/api";
import VCERNAlert from "../common/elements/VCERNAlert";
import VCERNTextField from "../common/elements/VCERNTextField";
import HeadingWithLine from "../common/elements/HeadingWithLine";

const useStyles = makeStyles((theme) => ({
  input: { margin: "10px 0" },
  title: {
    margin: "15px 0",
    fontWeight: "bold",
  },
  boldText: { fontWeight: "normal" },
  main: { margin: "20px 0", width: "100%" },
  inline: { margin: "10px 0 10px 10px", display: "flex" },
  icon: { marginRight: 15 },
  docImage: { width: 125, height: 112.7 },
  sendMessage: {
    marginRight: 10,
    [theme.breakpoints.down("md")]: { marginBottom: 20 },
  },
  buttonsHolder: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
}));

const isObjFalse = (obj) => {
  let condition = false;
  if (!obj) return true;
  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    if (typeof val == "object") {
      condition = condition || isObjFalse(val);
    } else {
      condition = condition || !Boolean(val);
    }
  });
  return condition;
};

function Profile({
  currentUser,
  type,
  setCurrentPageTitle,
  fetchDocs,
  token,
  triggerNotification,
  triggerMail,
  triggerSMS,
}) {
  const classes = useStyles();
  const location = useLocation();

  const [state, setstate] = useState({});
  const [docs, setDocs] = useState([]);
  const [messageModal, setMessageModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [mailModal, setMailModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [message, setMessage] = useState("");
  const [smsMessage, setSMSMessage] = useState("");
  const [mailSubject, setMailSubject] = useState("");
  const [mailMessage, setMailMessage] = useState("");
  useEffect(() => {
    setCurrentPageTitle(`Member Profile`);
    type === constants.USER_TYPE_MEMBER
      ? setstate(currentUser)
      : setstate(location?.state?.member);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    state?._id && fetchDocs(state?._id, token, setDocs);

    // eslint-disable-next-line
  }, [state]);

  const tagline = `${state?.address?.city}, ${state?.address?.state}`;
  const name = `${state?.first_name} ${state?.last_name}`;
  const phone = state?.phone;
  const email = state?.email;
  const address = `${state?.address?.street_address},${
    state?.address?.apt ? state?.address?.apt + ", " : ""
  } ${state?.address?.city}, ${state?.address?.state}, ${
    state?.address?.zip_code
  }, USA.`;
  const bName = `${state?.beneficiary?.first_name} ${state?.beneficiary?.last_name}`;
  const bDob = state?.beneficiary?.dob;
  const bPhone = state?.beneficiary?.phone;
  const bAddress = `${
    state?.beneficiary?.address?.apt
      ? state?.beneficiary?.address?.apt + ", "
      : ""
  }${state?.beneficiary?.address?.street_address}, ${
    state?.beneficiary?.address?.city
  }, ${state?.beneficiary?.address?.state}`.trim();
  const onSendNotification = async () => {
    await triggerNotification(
      { description: message, title: "Announcement", members: [state._id] },
      token,
      () => {
        setSuccessMessage("Notification Sent Successfully.");
      }
    );
    setMessage("");
    setNotificationModal(false);
  };
  const onSendMail = async () => {
    await triggerMail(
      { subject: mailSubject, message: mailMessage, members: [state._id] },
      token,
      () => {
        setSuccessMessage("Mail Sent Successfully.");
      }
    );
    setMailMessage("");
    setMailSubject("");
    setMailModal(false);
  };

  const onSendSMS = async () => {
    await triggerSMS(
      { message: smsMessage, members: [state._id] },
      token,
      () => {
        setSuccessMessage("SMS Sent Successfully.");
      }
    );
    setSMSMessage("");
    setMessageModal(false);
  };
  const isBeneficiaryAdded = !isObjFalse(state.beneficiary);
  console.log({ isBeneficiaryAdded });
  return (
    <Grid container>
      <DashboardHeader title={name} subTitle={tagline} id={state?._id} />
      <div className={classes.main}>
        {type === constants.USER_TYPE_ORG && (
          <div className={classes.buttonsHolder}>
            <VCERNButton
              startIcon={icons.notification}
              style={{ margin: "10px" }}
              value="Send a Notification"
              align="left"
              onClick={() => setNotificationModal(true)}
            />
            <VCERNButton
              style={{ margin: "10px" }}
              startIcon={icons.email}
              value="Send a Mail"
              align="left"
              onClick={() => setMailModal(true)}
            />
            <VCERNButton
              style={{ margin: "10px" }}
              startIcon={icons.messages}
              value="Send a Message"
              align="left"
              onClick={() => setMessageModal(true)}
            />
          </div>
        )}

        <div>
          <HeadingWithLine>Profile Info</HeadingWithLine>
          <div className={classes.inline}>
            <div className={classes.icon}>{icons.profile}</div>
            <VCERNTypography
              className={classes.boldText}
              variant="body1"
              value={state?.gender}
            />
          </div>
          <div className={classes.inline}>
            <div className={classes.icon}>{icons.phone}</div>
            <VCERNTypography
              className={classes.boldText}
              variant="body1"
              value={phone}
            />
          </div>
          <div className={classes.inline}>
            <div className={classes.icon}>{icons.email}</div>
            <VCERNTypography
              className={classes.boldText}
              variant="body1"
              value={email}
            />
          </div>
          <div className={classes.inline}>
            <div className={classes.icon}>{icons.state}</div>
            <VCERNTypography className={classes.boldText} variant="body1">
              {`${state?.address?.street_address}`}
              <br />
              {state?.address?.apt && (
                <>
                  {`${state?.address?.apt ? state?.address?.apt : ""} `}
                  <br />
                </>
              )}
              {` ${state?.address?.city}, ${state?.address?.state}, ${state?.address?.zip_code}`}
            </VCERNTypography>
          </div>
        </div>

        <div>
          <HeadingWithLine>Beneficiary Info</HeadingWithLine>
          {isBeneficiaryAdded ? (
            <>
              <div className={classes.inline}>
                <div className={classes.icon}>{icons.profile}</div>
                <VCERNTypography
                  className={classes.boldText}
                  variant="body1"
                  value={bName}
                />
              </div>
              <div className={classes.inline}>
                <div className={classes.icon}>{icons.relation}</div>
                <VCERNTypography
                  className={classes.boldText}
                  variant="body1"
                  value={state.beneficiary.relationship}
                />
              </div>
              <div className={classes.inline}>
                <div className={classes.icon}>{icons.date}</div>
                <VCERNTypography
                  className={classes.boldText}
                  variant="body1"
                  value={getFormattedDate(bDob)}
                />
              </div>
              <div className={classes.inline}>
                <div className={classes.icon}>{icons.phone}</div>
                <VCERNTypography
                  className={classes.boldText}
                  variant="body1"
                  value={bPhone}
                />
              </div>
              <div className={classes.inline}>
                <div className={classes.icon}>{icons.state}</div>
                <VCERNTypography className={classes.boldText} variant="body1">
                  {`${state?.beneficiary?.address?.street_address}`}
                  <br />
                  {state?.beneficiary?.address?.apt && (
                    <>
                      {`${
                        state?.beneficiary?.address?.apt
                          ? state?.beneficiary?.address?.apt
                          : ""
                      } `}
                      <br />
                    </>
                  )}
                  {` ${state?.beneficiary?.address?.city}, ${state?.beneficiary?.address?.state}, ${state?.beneficiary?.address?.zip_code}`}
                </VCERNTypography>
              </div>
              {!currentUser.beneficiary && state?.beneficiary?.email && (
                <VCERNButton
                  target="_blank"
                  href={`mailto:${state?.beneficiary?.email}`}
                  startIcon={icons.email}
                  value="Contact Beneficiary"
                  align="left"
                />
              )}
            </>
          ) : (
            <VCERNTypography
              className={classes.boldText}
              variant="body1"
              value={"Beneficiary not added"}
            />
          )}

          {/* <a href={state?.beneficiary?.email} target="_blank" rel="noreferrer">
                            Contact Beneficiary
                        </a> */}
        </div>

        <div>
          <HeadingWithLine>Documents</HeadingWithLine>
          <DocumentsList docs={docs} />
        </div>
      </div>
      <VCERNModal
        title="Send a Notification"
        buttonTittle="Submit"
        open={notificationModal}
        onClose={() => setNotificationModal(false)}
        onConfirm={onSendNotification}
      >
        <VCERNTextField
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Enter the message for the notification"
        />
      </VCERNModal>

      <VCERNModal
        title="Send a Message"
        buttonTittle="Submit"
        open={messageModal}
        onClose={() => setMessageModal(false)}
        onConfirm={onSendSMS}
      >
        <VCERNTextField
          value={smsMessage}
          onChange={(e) => setSMSMessage(e.target.value)}
          placeholder="Enter the message for the sms"
        />
      </VCERNModal>
      <VCERNModal
        title="Send a Mail"
        buttonTittle="Submit"
        open={mailModal}
        onClose={() => setMailModal(false)}
        onConfirm={onSendMail}
      >
        <VCERNTextField
          value={mailSubject}
          onChange={(e) => setMailSubject(e.target.value)}
          placeholder="Enter the subject for the mail"
        />
        <VCERNTextField
          value={mailMessage}
          onChange={(e) => setMailMessage(e.target.value)}
          placeholder="Enter the message for the mail"
        />
      </VCERNModal>
      <VCERNAlert
        message={successMessage}
        onClose={() => setSuccessMessage(false)}
        success={true}
      />
    </Grid>
  );
}
export default connect((data) => data, {
  setCurrentPageTitle: AC.setCurrentPageTitle,
  fetchDocs: AC.fetchDocs,
  triggerNotification: AC.triggerNotification,
  triggerMail: AC.triggerMail,
  triggerSMS: AC.triggerSMS,
})(Profile);
